import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 14a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-2a.5.5 0 100-1 .5.5 0 000 1zM13 9.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-2 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-2c.645 0 1.274-.068 1.88-.197a6.003 6.003 0 00-9.312-3.725A8.99 8.99 0 0012 21zm2.818-3.187c.441.717.773 1.51.97 2.353a9.03 9.03 0 003.122-2.399c-.622-.505-1.312-.767-2.019-.767-.725 0-1.437.277-2.073.813zm-1.253-1.56A7.973 7.973 0 008 14a7.966 7.966 0 00-4.375 1.302 9 9 0 1116.392.793C19.121 15.412 18.054 15 16.891 15c-1.253 0-2.39.478-3.326 1.253z",
      fill: "#292933"
    }
  )
);
export {
  t as default
};
